import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = { class: "fs-regular" }
const _hoisted_3 = ["innerHTML"]

import {
  computed, InputHTMLAttributes,
} from 'vue';

import IconCheck from '@/components/inputs/IconCheck.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: /*#__PURE__*/_mergeModels({
    light: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "error": {},
    "errorModifiers": {},
  }),
  emits: ["update:modelValue", "update:error"],
  setup(__props: any) {

const modelValue = _useModel(__props, "modelValue");
const error = _useModel<undefined | string | string[]>(__props, 'error');



const hasError = computed(() => (error.value ? error.value.length > 0 : false));

const errorMessage = computed(() => {
  if (hasError.value) {
    return Array.isArray(error.value)
      ? error.value[0]
      : error.value;
  }

  return '';
});

const value = computed({
  get(): unknown {
    return modelValue.value;
  },
  set(newValue: unknown): void {
    modelValue.value = newValue;
  },
});

const emitInput = (event: Event) => {
  value.value = (event.target as InputHTMLAttributes | undefined)?.checked;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-checkbox", {
        invalid: hasError.value,
        light: _ctx.light,
      }])
  }, [
    _createElementVNode("label", null, [
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          type: "checkbox",
          checked: modelValue.value,
          onInput: emitInput
        }, null, 40, _hoisted_1),
        _createElementVNode("span", null, [
          _createVNode(IconCheck)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default"),
        (hasError.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "io-shop-input--message fs-small",
              innerHTML: errorMessage.value
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})